/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from "react";
import TopicsPerson from "../topics-page/topics-person/topics-person";
import TopicsMovie from "../topics-page/topics-movie/topics-movie";
import TopicsOrganization from "../topics-page/topics-organization/topics-organization";

const TopicsPage = () => {
  return (
    <div className="main-page">
      <TopicsPerson />
      <TopicsMovie />
      <TopicsOrganization />
    </div>
  );
};

export { TopicsPage };
